// Generated by Copilot
import { Callout } from "@blueprintjs/core";
import { Link } from "react-router";

import { EmbedSvg } from "@/components/helpers/ui/EmbedSvg";
import { Box } from "@/components/layout/flexbox";
import { getMeetingPlatformIcon } from "@/components/pages_logged_in/program/components/set-components/configure-inputs/utils";
import { detectMeetingPlatform } from "@/components/pages_logged_in/program/components/utils";
import { INNER_BORDER_COLOR } from "@/css/constants";
import { PanelComponent } from "@/types/programs";
import { formatDate } from "@/utils/datetime";

interface MeetingButtonProps {
  url: string;
  date?: string;
  onEdit?: (component?: PanelComponent) => void;
}

export function MeetingButton({ url, date, onEdit }: MeetingButtonProps) {
  if (!url) {
    return (
      <Box>
        <Callout intent="warning" icon={null}>
          This group meeting doesn't have a link.{" "}
          <a
            onClick={(e) => {
              e.preventDefault();
              onEdit?.();
            }}
          >
            Click here to update
          </a>
        </Callout>
      </Box>
    );
  }

  const platform = detectMeetingPlatform(url);
  const meetingDate = formatDate(date, "eeee, MMM d 'at' h:mm a z");

  return (
    <div
      className="xs:rounded-md xs:p-3.5 w-full bg-white md:rounded-lg md:p-4"
      style={{
        border: `1px solid ${INNER_BORDER_COLOR}`,
      }}
    >
      <Link
        className="text-maintext w-full font-semibold"
        target="_blank"
        to={url}
      >
        <div className="xs:gap-3.5 flex items-center md:gap-4">
          <EmbedSvg
            className="xs:w-10 xs:h-10 md:h-12.5 md:w-12.5"
            src={`${getMeetingPlatformIcon(platform)} `}
          />
          <div className="xs:gap-0.5 flex flex-col md:gap-1.5">
            <div className="xs:text-sm font-semibold md:text-base">
              Join {platform !== "Others" ? platform : ""} Meeting
            </div>
            {date && (
              <div className="xs:text-sm font-normal text-gray-500 md:text-base">
                {meetingDate}
              </div>
            )}
          </div>
        </div>
      </Link>
    </div>
  );
}
